export default "__VITE_ASSET__B_LECfb1__"